import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import NavigationRail from "@/views/navigation-views/navigation-rail.vue";
import NavigationBar from "@/views/navigation-views/navigation-bar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SideMenu',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(NavigationRail),
    _createVNode(NavigationBar)
  ], 64))
}
}

})